module.exports = __webpack_public_path__ + "img/tasks.637d92bc.svg";